import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Route, Router } from '@angular/router';
import { BreadCrumb } from './breadcrumb';
import { filter, map } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { merge, Subscription } from 'rxjs';
import { AppInitializerService } from '../../../core/services/app-initializer.service';
import { UserService } from '../../../core/services/user.service';

@Component({
    selector: 'cmn-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {

    @Input() maxLength: number;

    private subscriptions: Subscription = new Subscription();
    public breadcrumbs: Array<any>;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userService: UserService
    ) {
        this.subscriptions.add(
            merge(
                this.router.events,
                this.userService.userIsLogin$
            )
                .pipe(
                    filter((event: any) => {
                        return event instanceof NavigationEnd || event;
                    })
                )
                .pipe(
                    map(() => this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root))
                )
                .subscribe()
        );
    }

    ngOnInit() {
    }

    public buildBreadCrumb(route: ActivatedRoute): Array<BreadCrumb> {

        const breadcrumbs: Array<BreadCrumb> = [new BreadCrumb('Start', '')];

        let currentRoute = route;

        while (!isNullOrUndefined(currentRoute.firstChild)) {
            currentRoute = currentRoute.firstChild;
            const routeConfig: Route = currentRoute.routeConfig;
            const data = isNullOrUndefined(routeConfig.data) ? [] : routeConfig.data;

            if (isNullOrUndefined(data['pageTitle']) && isNullOrUndefined(data['breadCrumbTitle'])) {
                continue;
            }

            const previousBreadcrumb = breadcrumbs[breadcrumbs.length - 1];

            breadcrumbs.push(BreadCrumb.createFromRoute(currentRoute, previousBreadcrumb.url));
        }

        let croppedBreadcrumbs: Array<BreadCrumb> = [];
        if (!isNullOrUndefined(this.maxLength) && breadcrumbs.length > this.maxLength) {
            croppedBreadcrumbs.push(new BreadCrumb('Start', ''));
            croppedBreadcrumbs.push(new BreadCrumb('...', undefined, true));
            croppedBreadcrumbs = croppedBreadcrumbs.concat(breadcrumbs.slice(-(this.maxLength - 2)));
        } else {
            croppedBreadcrumbs = breadcrumbs;
        }
        return croppedBreadcrumbs;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

}
